module.exports = __webpack_public_path__ + "f5f9425151a2295ebd5e6eb0fab374c9.MP3";